import { Environment } from '../environment';

export const environment: Environment = {
    apiUrl: 'https://dev-api-kfp.techcrowd.space',
    development: true,
};
